import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { SupabaseService } from '../../services/supabase/supabase.service';
import { TenantsService } from '../../services/tenants/tenants.service';

@Injectable({
  providedIn: 'root',
})
class AuthService {
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    supabase: SupabaseService,
    router: Router,
    tenants: TenantsService,
  ): Promise<boolean | UrlTree> {
    const tenant = route.paramMap.get('id');
    const session = await supabase.getSession();
    const allowedTenants = await tenants.getTenants();

    console.log(session);

    // check if the user has one session elso try to log in
    if (session && tenant) {
      if (allowedTenants.findIndex((e) => e.name === tenant) === -1) {
        return router.createUrlTree([`${tenant}/unauthorized`]);
      } else {
        tenants.activeTenant = tenant;
        return true;
      }
    } else if (session === null && tenant) {
      return router.createUrlTree([`${tenant}/login`], {
        queryParams: { redirectUrl: state.url },
      });
    } else {
      return false;
    }
  }
}

export const authGuard: CanActivateFn = (route, state) => {
  return inject(AuthService).canActivate(
    route,
    state,
    inject(SupabaseService),
    inject(Router),
    inject(TenantsService),
  );
};
